// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ArrowDownIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 16 282">
    <path
      fill="currentColor"
      d="M9 1a1 1 0 0 0-2 0zM7.3 281.7a1 1 0 0 0 1.4 0l6.37-6.36a1 1 0 1 0-1.41-1.41L8 279.59l-5.66-5.66a1 1 0 1 0-1.41 1.41zM7 1v280h2V1z"
    />
  </svg>,
  "ArrowDown",
);
export default ArrowDownIcon;
